module.exports = __webpack_public_path__ + "static/aus-47f725c339132ecde4ccca4b54fae386.png";